import { createLazyComponent, LazyModule } from 'owa-bundling';
import { isSubjectPickerSupported } from 'owa-mail-subject-picker-connector';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "SubjectPicker" */ './lazyIndex');
});
// Delay loaded components
export var SubjectPicker = createLazyComponent(lazyModule, function (m) { return m.SubjectPicker; });
export function loadModule() {
    if (isSubjectPickerSupported()) {
        lazyModule.import();
    }
}
//# sourceMappingURL=index.js.map